import { useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card } from "@/components/ui/card";
import { Leaf, Loader2, KeyRound } from "lucide-react";

export default function AterstallLosenord() {
  const { token } = useParams();
  const navigate = useNavigate();
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (pw.length < 8) { setError("Lösenordet måste vara minst 8 tecken."); return; }
    if (pw !== pw2) { setError("Lösenorden matchar inte."); return; }
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, new_password: pw });
      toast.success("Lösenordet är uppdaterat – logga in med ditt nya lösenord.");
      navigate("/login");
    } catch (err) {
      setError(formatApiError(err.response?.data?.detail));
    } finally { setLoading(false); }
  };

  return (
    <div className="hamn-bg min-h-screen flex items-center justify-center p-6">
      <Card className="w-full max-w-md rounded-2xl border-border p-8 md:p-10">
        <div className="flex items-center gap-2 mb-6">
          <div className="h-9 w-9 rounded-lg bg-primary flex items-center justify-center text-primary-foreground"><Leaf className="h-5 w-5" /></div>
          <span className="font-head font-bold text-primary text-lg">HAMN CV Studio</span>
        </div>
        <h1 className="font-head text-3xl font-bold flex items-center gap-2"><KeyRound className="h-6 w-6 text-primary" /> Nytt lösenord</h1>
        <p className="text-muted-foreground mt-2 mb-6">Välj ett nytt lösenord till ditt konto.</p>
        <form onSubmit={submit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="pw">Nytt lösenord</Label>
            <Input data-testid="reset-pw-input" id="pw" type="password" required value={pw}
              onChange={(e) => setPw(e.target.value)} placeholder="Minst 8 tecken" />
          </div>
          <div className="space-y-2">
            <Label htmlFor="pw2">Bekräfta lösenord</Label>
            <Input data-testid="reset-pw2-input" id="pw2" type="password" required value={pw2}
              onChange={(e) => setPw2(e.target.value)} placeholder="Upprepa lösenordet" />
          </div>
          {error && <p data-testid="reset-error" className="text-sm text-destructive">{error}</p>}
          <Button data-testid="reset-submit-btn" type="submit" className="w-full rounded-full h-11" disabled={loading}>
            {loading && <Loader2 className="h-4 w-4 mr-2 animate-spin" />} Spara nytt lösenord
          </Button>
        </form>
        <p className="text-sm text-muted-foreground mt-6 text-center">
          <Link to="/login" className="text-primary font-medium hover:underline">Tillbaka till inloggning</Link>
        </p>
      </Card>
    </div>
  );
}
